module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_1.8f8a039e.png";